import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TransformYourVision from "./sections/TransformYourVision";
import TheIntegrationJourney from "./sections/TheIntegrationJourney";
import Insights from "./sections/Insights";
import TheKindoAdvantage from "./sections/TheKindoAdvantage";
import EnterpriseHorizon from "./sections/EnterpriseHorizon";
import SecurityTrust from "./sections/SecurityTrust";
import MembershipPricing from "./sections/MembershipPricing";
import CommunityVoices from "./sections/CommunityVoices";
import CommonInquiries from "./sections/CommonInquiries";
import ReserveYourTime from "./sections/ReserveYourTime";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TransformYourVision />
      <TheIntegrationJourney />
      <Insights />
      <TheKindoAdvantage />
      <EnterpriseHorizon />
      <SecurityTrust />
      <MembershipPricing />
      <CommunityVoices />
      <CommonInquiries />
      <ReserveYourTime />
      <Footer />
    </div>;
}